module.exports = __webpack_public_path__ + "static/media/1POLICY1.fe3afb52.jpg";